import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "candidates",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "candidates" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
});
